import { IKeys } from "./KeystrokePreview";

export const KEYSTROKE_DEFINITIONS = {
    SUBMIT_MODAL_FORM: ["ctrl", "enter"] as IKeys[],
    CLOSE_MODAL: ["esc"] as IKeys[],
    KEYS_SITE_NEW_KEY: ["ctrl", "k"] as IKeys[],
    KEYS_SITE_SEARCH: ["ctrl", "shift", "f"] as IKeys[],
    PROJECTS_SITE_NEW_PROJECT: ["ctrl", "p"] as IKeys[]
};
